import React from 'react';

import AllAPIsForm from './AllAPIs/components/form/AllAPIsForm';
import APIOneForm from './APIOne/components/form/APIOneForm';
import APITwoBrandForm from './APITwo/components/form/APITwoBrandForm';
import APITwoCelebForm from './APITwo/components/form/APITwoCelebForm';
import APIThreeForm from './APIThree/components/form/APIThreeForm';
import APIFourForm from './APIFour/components/form/APIFourForm';
import APIFiveForm from './APIFive/components/form/APIFiveForm';
import APISixForm from './APISix/components/form/APISixForm';
import APISevenForm from './APISeven/components/form/APISevenForm';
import APIEightForm from './APIEight/components/form/APIEightForm';

const APITesting = () => {
  return (
    <div>
      <div className="api-full">
        <h2 className="h3">Full API Form</h2>
        <p>
          <strong>Description:</strong> This combines all API endpoints - API
          Testing New
        </p>
        <AllAPIsForm />
      </div>
      <div claasName="api-one">
        <h2 className="h3">1 - AI Results</h2>
        <p>
          <strong>Description:</strong> This will fetch the AI generated images
          and copy to be used as mock social media posts.
        </p>
        <APIOneForm />
      </div>
      <div className="api-two">
        <h2 className="h3">2 - Geographical Search Interest</h2>
        <p>
          <strong>Description:</strong> This will fetch the historical and
          geographical search interest in the brand and the celebrity. Due to
          Google Trends anti-scraping techniques, we have to invoke two API
          calls (one for brand and one for celebrity).
        </p>
        <h3 className="h4">Brand</h3>
        <APITwoBrandForm />
        <h3 className="h4">Celebrity</h3>
        <APITwoCelebForm />
      </div>
      <div className="api-three">
        <h2 className="h3">3 - Brand Mentions Last Year</h2>
        <p>
          <strong>Description:</strong> This will fetch the total number of
          mentions a brand received in 2023. This is used to calculate the hero
          score.
        </p>
        <APIThreeForm />
      </div>
      <div className="api-four">
        <h2 className="h3">4 - Model Results</h2>
        <p>
          <strong>Description:</strong> This will fetch the predicted media
          mentions and predicted reach for a potential collaboration
        </p>
        <APIFourForm />
      </div>
      <div className="api-five">
        <h2 className="h3">5 - Collab Suggestions</h2>
        <p>
          <strong>Description:</strong> This will fetch suggestions for
          potential collaborations between a brand and a celebrity.
        </p>
        <APIFiveForm />
      </div>
      <div className="api-six">
        <h2 className="h3">6 - AI Chat Bot</h2>
        <p>
          <strong>Description:</strong> This will start a AI Chat for
          the fusion between a brand and a celebrity.
        </p>
        <APISixForm />
      </div>
      <div className="api-seven">
        <h2 className="h3">7 - Presentation Builder</h2>
        <p>
          <strong>Description:</strong> This will generate a presentation for
          the fusions between a brand and a celebrity.
        </p>
        <APISevenForm />
      </div>
      <div className="api-eight">
        <h2 className="h3">7 - Launchpad</h2>
        <p>
          <strong>Description:</strong> This start a AI Chat for the Launchpad
          bot.
        </p>
        <APIEightForm />
      </div>
    </div>
  );
};

export default APITesting;
